import {HeaderController} from './header.controller';
import template from './header.template.html';

export const HeaderComponent = {
    controller: HeaderController,
    templateUrl: template
};



// WEBPACK FOOTER //
// ./src/js/components/header/header.component.js